import { NotifyHelper } from "../../../helpers/toast";
import { eDotXetHocVuPhamViActionsObj } from "../../action-types/xet-hoc-vu/IDotXetHocVuPhamViActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const dotXetHocVuPhamViActions = {
    ...generateActions(eDotXetHocVuPhamViActionsObj, "DOT_XET_HOC_VU_PHAM_VI"),
    ...generateActionForKey(eDotXetHocVuPhamViActionsObj, "DOT_XET_HOC_VU_PHAM_VI", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eDotXetHocVuPhamViActionsObj, "DOT_XET_HOC_VU_PHAM_VI", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eDotXetHocVuPhamViActionsObj, "DOT_XET_HOC_VU_PHAM_VI", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eDotXetHocVuPhamViActionsObj, "DOT_XET_HOC_VU_PHAM_VI", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),

}